export * from './errors';

export const REQUEST_STATUS = {
    idle: 'idle',
    loading: 'loading',
    succeeded: 'succeeded',
    failed: 'failed',
} as const;

export type RequestStatus = keyof typeof REQUEST_STATUS;
